<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="620"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <div
              class="pa-4 popup-header">
              <div
                class="title font-weight-bold black--text text-center mb-1">
                Keterlibatan Pegawai Dilingkungan Sekitar
              </div>

              <div
                class="body-1 text-center">
                Tentukan nilai berdasarkan informasi dibawah ini:
              </div>
            </div>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div
                    class="body-2 mb-8">
                    <ul
                      style="position: relative; left: -10px;">
                      <li
                        v-for="(item, index) in info"
                        :key="index"
                        :class="index < info.length - 1 ? 'mb-2' : ''"
                        v-html="item">  
                      </li>
                    </ul>
                  </div>

                  <ValidationProvider 
                    name="Jumlah Keterlibatan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Jumlah Keterlibatan
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      hide-details
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      placeholder="Contoh. 3"

                      @focus="$event.target.select()"

                      v-model="form.label_score"
                      :success="form.label_score !== '' && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.label_score !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Skor" 
                    rules="required|max_100:100"
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      
                      Skor
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      :color="set_color"
                      hide-details
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      min="0"

                      placeholder="Contoh. 70"

                      @focus="$event.target.select()"

                      v-model="form.score"
                      :success="form.score !== '' && valid"
                      :error-messages="errors"
                      class="mb-2"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.score !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.reset"
          @keydown.esc="dialog.reset = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right font-weight-bold popup-header">
              Reset Nilai

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin mereset nilai data <b class="font-weight-bold black--text">Pengembangan Diri Keterlibatan Pegawai Dilingkungan Sekitar</b> ini?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="resetes()"
                :loading="process.reset"
                :disabled="process.reset"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Reset
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.reset = false; dialog.fullscreen = false; selected.reset = {};"
                :disabled="process.reset"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.attachment"
          @keydown.esc="dialog.attachment = false"
          :fullscreen="dialog.fullscreen"
          width="1080"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right font-weight-bold popup-header">
              Lampiran

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.attachment = false; dialog.fullscreen = false; selected.item = {};"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text v-if="Object.keys(selected.item).length > 0"
              class="mt-4">
              <div v-if="selected.item.attachment.split('.').pop() !== 'pdf'">
                <v-img
                  contain
                  alt="amanata" 
                  width="100%"
                  height="auto"
                  :src="selected.item.attachment"
                  class="ma-auto border-radius">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>

              <div v-else>
                <iframe 
                  :src="`${selected.item.attachment}#toolbar=0`" 
                  allowfullscreen
                  frameborder="0" 
                  width="100%"
                  height="600"
                  style="border-radius: 10px; border: 2px solid #323639;">
                </iframe>
              </div>
            </v-card-text>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="dialog.attachment = false; dialog.fullscreen = false; selected.item = {};"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-card 
            flat
            class="mb-6"
            style="border-radius: 10px; border: 1px solid #E7E7E7;">
            <v-card-text
              :style="list.length > 0 ? 'height: calc(100vh - 510px);' : 'height: calc(100vh - 438px);'"
              style="overflow-y: auto;">
              <v-skeleton-loader
                v-for="(item, index) in process.load ? 2 : list"
                :key="index"
                :loading="process.load"
                :class="index < list.length -1 ? 'mb-4' : ''"
                type="article">
                <v-expansion-panels
                  flat>
                  <v-expansion-panel
                    style="background: #f0f0f0; border-radius: 10px;">
                    <v-expansion-panel-header>
                      <div>
                        <div
                          class="font-weight-bold mb-3"
                          :style="`color: ${set_color};`">
                          {{ item.title }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div
                            class="d-flex align-center mr-8">
                            <v-icon small>mdi-calendar-range</v-icon>
                            
                            <span
                              class="caption ml-1">
                              {{ item.datetime | date }}
                            </span>
                          </div>

                          <div
                            class="d-flex align-center">
                            <v-icon small>mdi-clock-time-four-outline</v-icon>
                            
                            <span
                              class="caption ml-1">
                              {{ item.datetime | time }} WIB
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                      <v-divider
                        class="mb-3"
                        style="border: 2px solid #e0e0e0; border-radius: 50px;" />
                        
                      <div
                        class="mb-2"
                        :style="`color: ${set_color}; font-weight: 500;`">
                        Deskripsi Pekerjaan
                      </div>

                      <v-card
                        flat
                        class="mb-4"
                        style="border-radius: 10px;">
                        <v-card-text
                          class="line-text-second"
                          style="padding-top: 12px;">
                          {{ item.desc }}
                        </v-card-text>
                      </v-card>

                      <v-card
                        flat
                        style="border-radius: 10px;">
                        <v-card-text
                          class="line-text-second d-flex align-start"
                          style="padding-top: 12px;">
                          <v-icon>mdi-attachment</v-icon>

                          <span v-if="item.attachment !== ''"
                            @click="dialog.attachment = true; selected.item = item;"
                            class="blue--text cursor-pointer ml-2">
                            {{ item.attachment }}
                          </span>

                          <span v-else
                            class="ml-2">
                            Tidak ada lampiran
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-skeleton-loader>

              <v-card v-if="!process.load && list.length < 1"
                flat
                style="border-radius: 10px; border: 2px dashed #e0e0e0;">
                <v-card-text
                  class="d-flex align-center">
                  <v-icon size="20">mdi-information-slab-circle-outline</v-icon>

                  <span
                    class="ml-2">
                    Belum ada data Keterlibatan Pegawai Dilingkungan Sekitar
                  </span>
                </v-card-text>
              </v-card>
            </v-card-text>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetchData($event)" 
              @reloadPage="fetchData($event)" 
              :model="pagination"/>
          </v-card>

          <v-card 
            flat
            :color="set_color_rgb_down"
            style="border-radius: 10px; border: 1px solid #E7E7E7;">
            <v-row>
              <v-col
                cols="12"
                :md="detail_skor.id !== '' ? 9 : 10"
                class="py-0 pr-0">
                <v-card
                  @click="dialog.form = true; reset();"
                  flat
                  color="transparent"
                  style="border-radius: 10px 0px 0px 10px;">
                  <v-card-text
                    class="font-weight-bold black--text">
                    Skor Keterlibatan Pegawai Dilingkungan Sekitar{{ detail_skor.indicator_score < 1 ? ', klik disini' : ` adalah ${detail_skor.indicator_score}` }}
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="2"
                class="py-0"
                :class="detail_skor.id !== '' ? 'px-0' : 'pl-0'">
                <v-card
                  flat
                  min-height="56"
                  :style="detail_skor.id !== '' ? 'border-radius: 0px;' : 'border-radius: 0px 10px 10px 0px;'">
                  <v-card-text
                    class="font-weight-bold text-center">
                    {{ detail_skor.indicator_label_score > 0 ? detail_skor.indicator_label_score : '0' }}
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col v-if="detail_skor.id !== ''"
                cols="12"
                md="1"
                class="py-0 pl-0">
                <v-card
                  @click="toReset()"

                  flat
                  min-height="56"
                  color="orange"
                  style="border-radius: 0px 10px 10px 0px;">
                  <v-card-text
                    class="text-center">
                    <v-icon color="white">mdi-reload-alert</v-icon>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      },
      summary: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          
          form: false,
          reset: false,
          attachment: false
        },

        selected: {
          item: {},
          reset: {}
        },

        info: [
          'Kurang dari sama dengan 1 (Skor 30)',
          'Lebih dari 1 sampai kurang dari sama dengan 3 (Skor 60)',
          'Lebih dari 3 (Skor 100)'
        ],

        detail_skor: {
          id: '',
          indicator_summary_id: '',
          user_id: '',
          indicator_label_score: 0,
          indicator_score: 0
        },

        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          summary_id: '',
          user_id: '',
          label_score: 0,
          score: 0
        },

        process: {
          load: false,

          form: false,
          reset: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'form.label_score': function(val) {
        if (val === '' || val === 0) {
          this.form.score = ''
        } else {
          if (val <= 1) {
            this.form.score = 30
          }
  
          if (val > 1 && val <= 3) {
            this.form.score = 60
          }

          if (val > 3) {
            this.form.score = 100
          }
        }
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchData()
        this.fetchSkor()
      },

      async fetchData (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,

          user_id: this.detail.id,

          start_date: this.summary.start_date,
          end_date: this.summary.end_date
        }

        await get(`kpi_v2/keterlibatan_pegawai/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.list = res.results.data
            this.pagination = res.results.pagination
          }
        })
      },

      async fetchSkor () {
        let params = {
          user_id: this.detail.id,

          indicator_summary_id: this.summary.id,

          start_date: this.summary.start_date,
          end_date: this.summary.end_date
        }

        await get('kpi_v2/keterlibatan_pegawai/data', { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail_skor = res.results.data.length > 0 ? res.results.data[0] : {
              id: '',
              indicator_summary_id: this.summary.id,
              user_id: this.detail.id,
              indicator_label_score: 0,
              indicator_score: 0
            }
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        let params = {
          user_id: this.detail.id,

          start_date: this.summary.start_date,
          end_date: this.summary.end_date
        }

        get('kpi_v2/keterlibatan_pegawai/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form = {
              id: this.detail_skor.id,
              summary_id: this.detail_skor.indicator_summary_id,
              user_id: this.detail_skor.user_id,
              label_score: this.detail_skor.indicator_label_score < 1 ? res.results.label : this.detail_skor.indicator_label_score,
              score: this.detail_skor.indicator_score < 1 ? res.results.score : this.detail_skor.indicator_score
            }
          }
        })

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.detail_skor.indicator_label_score < 1 ? 'kpi_v2/keterlibatan_pegawai/add_score' : 'kpi_v2/keterlibatan_pegawai/update_score'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchSkor()

              this.$emit('refresh', true)
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toReset () {
        this.selected.reset = this.detail_skor

        this.dialog.reset = true
      },

      async resetes () {
        this.message.error = ''

        this.process.reset = true

        await post(`kpi_v2/keterlibatan_pegawai/reset_score`, {
          data: {
            id: this.selected.reset.id
          }
        }).then(response => {
          let res = response.data

          this.process.reset = false

          if (res.status === 200) {

            this.dialog.reset = false

            this.selected.reset = {}
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchSkor()

            this.$emit('refresh', true)
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>